import { format } from "date-fns";

export default function StringToDate(date_str) {
    return format(new Date(date_str), 'dd.MM.yyyy')
}